import { render, staticRenderFns } from "./CurrentHoldingsTable.vue?vue&type=template&id=d4067630&scoped=true"
import script from "./CurrentHoldingsTable.vue?vue&type=script&lang=ts"
export * from "./CurrentHoldingsTable.vue?vue&type=script&lang=ts"
import style0 from "./CurrentHoldingsTable.vue?vue&type=style&index=0&id=d4067630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4067630",
  null
  
)

export default component.exports